// Libs
import React, { useEffect, useState } from 'react';
import { notification } from 'antd';
// Utils
import { filterOption } from 'utils/libs';
// Services
import { ApiServiceV2 } from 'services';
// Hooks
import { useCreatePaycut } from 'modules/Billing/hooks';
// Components
import { Button, DatePicker, Divider, TextField, Wrapper } from 'components';
import Select from 'components/Select';

const { Option } = Select;
const { Input } = TextField;

const CreatePaycut = ({ onSuccess }) => {
	const { submitPaycut, isLoading } = useCreatePaycut();

	const [values, setValues] = useState({
		name: '',
		from_date: null,
		to_date: null,
		department_id: null,
		coin_id: null,
	});
	const [departments, setDepartments] = useState([]);
	const [coins, setCoins] = useState([]);

	useEffect(() => {
		ApiServiceV2.get({ url: '/departments' })
			.then(data => setDepartments(Array.isArray(data) ? data : []))
			.catch(() => notification.error({ message: 'No se pudieron cargar los departamentos', className: 'notification-dark-style', duration: 5 }));

		ApiServiceV2.get({ url: '/coins' })
			.then(data => setCoins(Array.isArray(data) ? data : []))
			.catch(() => notification.error({ message: 'No se pudieron cargar las monedas', className: 'notification-dark-style', duration: 5 }));
	}, []);

	const handleSubmit = () =>
		submitPaycut({
			payload: {
				name: values.name,
				from_date: values.from_date,
				to_date: values.to_date,
				department_id: values.department_id,
				coin_id: values.coin_id,
			},
			onSuccess,
		});

	return (
		<Wrapper flexDirection='column' padding='0 0 16px 0' width='100%'>
			<Divider color='gray' orientation='left' style={{ margin: '16px 0 0 0' }}>
				Datos del Cobro
			</Divider>

			{/* NAME */}
			<Input
				margin='20px 0 0 0'
				placeholder='Nombre*'
				maxLength={30}
				value={values.name}
				onChange={e => setValues(prev => ({ ...prev, name: e.target.value }))}
			/>

			{/* FROM DATE */}
			<DatePicker
				style={{ width: '100%', marginTop: '10px' }}
				placeholder='Desde*'
				value={values.from_date}
				onChange={value => setValues(prev => ({ ...prev, from_date: value }))}
			/>

			{/* TO DATE */}
			<DatePicker
				style={{ width: '100%', marginTop: '10px' }}
				placeholder='Hasta*'
				value={values.to_date}
				onChange={value => setValues(prev => ({ ...prev, to_date: value }))}
			/>

			{/* DEPARTMENT */}
			<Select
				showSearch
				placeholder='Departamento*'
				margin='10px 0 0 0'
				width='100%'
				value={values.department_id}
				filterOption={filterOption}
				onChange={value => setValues(prev => ({ ...prev, department_id: value }))}
			>
				{departments.map((dept, idx) => (
					<Option key={idx} value={dept.id}>
						<em>{dept.name}</em>
					</Option>
				))}
			</Select>

			{/* COIN */}
			<Select
				showSearch
				placeholder='Moneda*'
				margin='10px 0 0 0'
				width='100%'
				value={values.coin_id}
				filterOption={filterOption}
				onChange={value => setValues(prev => ({ ...prev, coin_id: value }))}
			>
				{coins.map((coin, idx) => (
					<Option key={idx} value={coin.id}>
						<em>{coin.name}</em>
					</Option>
				))}
			</Select>

			<Wrapper width='100%' justifyContent='center'>
				<Button
					margin='16px 0 0 0'
					mode='primary'
					disabled={isLoading}
					onClick={handleSubmit}
				>
					{isLoading ? 'Creando...' : 'Crear'}
				</Button>
			</Wrapper>
		</Wrapper>
	);
};

export default CreatePaycut;
